// extracted by mini-css-extract-plugin
export var container = "_ef-1";
export var cornerButtonContainer = "_ef-6";
export var disabled = "_ef-2";
export var dragActive = "_ef-3";
export var fileContainer = "_ef-5";
export var hiddenInput = "_ef-4";
export var widthContainer = "_ef-0";